const SplitTestConstants = {
  ZRM_FLEXIBLE_PROPERTY_CREATION: 'zrm_flexible_property_creation',
} as const;

export default SplitTestConstants;
